import abstract from './abstract.vue';
import checkbox from './checkbox.vue';
import radioGroup from './radio-group.vue';
import checkboxGroup from './checkbox-group.vue';
import input from './input.vue';
import number from './number.vue';
import select from './select.vue';
import button from './button.vue';
import datePicker from './date-picker.vue';
import align from './align.vue';
import alignGroup from './align-group.vue';
import fontStyle from './font-style.vue';
import color from './color.vue';
import slider from './slider.vue';
import fontFamily from './font-family.vue';
import upload from './upload.vue';
import switchy from './switchy.vue';
import translate from './translate.vue';
import textCase from './textCase.vue';

export default [
  { name: 'abstract', component: abstract },
  { name: 'checkbox', component: checkbox },
  { name: 'radio-group', component: radioGroup },
  { name: 'checkbox-group', component: checkboxGroup },
  { name: 'input', component: input },
  { name: 'number', component: number },
  { name: 'select', component: select },
  { name: 'button', component: button },
  { name: 'date-picker', component: datePicker },
  { name: 'align', component: align },
  { name: 'align-group', component: alignGroup },
  { name: 'font-style', component: fontStyle },
  { name: 'color', component: color },
  { name: 'slider', component: slider },
  { name: 'font-family', component: fontFamily },
  { name: 'upload', component: upload },
  { name: 'switchy', component: switchy },
  { name: 'translate', component: translate },
  { name: 'text-case', component: textCase },
];
